var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3074_17481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17 33.1406C26.1127 33.1406 33.5 25.7533 33.5 16.6406C33.5 7.52793 26.1127 0.140625 17 0.140625C7.8873 0.140625 0.5 7.52793 0.5 16.6406C0.5 25.7533 7.8873 33.1406 17 33.1406Z",
    fill: "url(#paint0_linear_3074_17481)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.97012 16.4631C12.7802 14.3675 15.9877 12.9859 17.5926 12.3183C22.1748 10.4124 23.1269 10.0814 23.7475 10.0704C23.884 10.068 24.1892 10.1019 24.3869 10.2623C24.5538 10.3977 24.5997 10.5807 24.6217 10.7091C24.6437 10.8375 24.6711 11.1301 24.6493 11.3587C24.401 13.9677 23.3266 20.2991 22.7799 23.2213C22.5487 24.4578 22.0932 24.8724 21.6523 24.9129C20.6941 25.0011 19.9665 24.2797 19.0385 23.6714C17.5863 22.7194 16.7659 22.1268 15.3562 21.1979C13.7272 20.1244 14.7832 19.5343 15.7116 18.5701C15.9546 18.3177 20.1764 14.4777 20.2581 14.1293C20.2683 14.0858 20.2778 13.9234 20.1813 13.8376C20.0848 13.7518 19.9424 13.7812 19.8397 13.8045C19.694 13.8376 17.3741 15.3709 12.8799 18.4047C12.2214 18.8568 11.6249 19.0772 11.0905 19.0656C10.5014 19.0529 9.36814 18.7325 8.52568 18.4586C7.49237 18.1228 6.67111 17.9452 6.74262 17.3747C6.77987 17.0776 7.18904 16.7737 7.97012 16.4631Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3074_17481",
    x1: 17,
    y1: 0.140625,
    x2: 17,
    y2: 32.8959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3074_17481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    fill: "white",
    transform: "translate(0.5 0.140625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.15bfceaec1bd1cfc572757af8feb2a3e.svg";
export { ForwardRef as ReactComponent };